export default __webpack_public_path__ + "img/LP_Explainer-Legacy-Transformation-AI.c67e41cb.png";